export default __webpack_public_path__ + "static/media/order_icon.267ad1b0.svg";